export function required(v) {
  return (
    (v !== undefined && v !== "" && v !== null) ||
    "このフィールドを空白にすることはできません。"
  );
}

export function inArray(v, array) {
  return array.includes(v) || "このフィールドを空白にすることはできません。";
}

export function phone(v) {
  return /^[0-9-]+$/.test(v) || "このフィールドには数値を入力してください。";
}

export function max(v, max) {
  return (
    v.length <= max || "このフィールドは" + max + "文字を超えてはなりません。"
  );
}

export function digits(v, value) {
  return (
    (v !== undefined && v !== "" && v !== null && v.length == value) ||
    "このフィールドには" + value + "桁の数値を入力してください。"
  );
}

export function date(v) {
  return (
    /^\d{4}\/\d{2}\/\d{2}$/.test(v) ||
    "The field must match the format YYYY/MM/DD."
  );
}

export function isSelectedCounselor(counselor_id) {
  return (
    (counselor_id !== undefined && counselor_id !== "" && counselor_id !== null)
    || "事前に実施COを指定してください。"
  );
}

